<div class="sign-settings-container">
    <!-- Access Denied Message -->
    <div *ngIf="!isAdmin" class="access-denied-container">
        <mat-card>
            <mat-card-content class="text-center py-5">
                <mat-icon class="access-denied-icon">lock</mat-icon>
                <h3 class="mt-3">Acces Restricționat</h3>
                <p class="text-muted">Nu aveți permisiunea de a accesa această secțiune.</p>
                <p class="text-muted">Doar utilizatorii cu rol de administrator pot configura serviciul de semnare digitală.</p>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Main Content - Only for Admin Users -->
    <ng-container *ngIf="isAdmin">
        <!-- Loading Spinner -->
        <div class="section-spinner position-absolute" *ngIf="isLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>

        <!-- Service Status Section -->
        <mat-card class="mb-3">
        <mat-card-header>
            <mat-card-title>Status Serviciu Semnare Digitală</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="row mt-3">
                <div class="col-md-4">
                    <div class="status-card" [ngClass]="isHealthy ? 'status-ok' : 'status-error'">
                        <mat-icon>{{ isHealthy ? 'check_circle' : 'error' }}</mat-icon>
                        <span class="status-label">Health</span>
                        <span class="status-value">{{ isHealthy ? 'Funcțional' : 'Indisponibil' }}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="status-card" [ngClass]="isReady ? 'status-ok' : 'status-error'">
                        <mat-icon>{{ isReady ? 'check_circle' : 'error' }}</mat-icon>
                        <span class="status-label">Ready</span>
                        <span class="status-value">{{ isReady ? 'Pregătit' : 'Nepregătit' }}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="status-card" [ngClass]="healthData?.version ? 'status-info' : 'status-neutral'">
                        <mat-icon>info</mat-icon>
                        <span class="status-label">Versiune</span>
                        <span class="status-value">{{ healthData?.version || 'N/A' }}</span>
                    </div>
                </div>
            </div>

            <!-- Ready Components -->
            <div class="row mt-3" *ngIf="readyData?.components">
                <div class="col-12">
                    <h5>Componente Serviciu</h5>
                </div>
                <div class="col-md-4">
                    <div class="component-status" [ngClass]="getReadyComponentClass('database')">
                        <mat-icon>{{ getReadyComponentIcon('database') }}</mat-icon>
                        <span>Database: {{ getReadyComponentStatus('database') }}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="component-status" [ngClass]="getReadyComponentClass('redis')">
                        <mat-icon>{{ getReadyComponentIcon('redis') }}</mat-icon>
                        <span>Redis: {{ getReadyComponentStatus('redis') }}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="component-status" [ngClass]="getReadyComponentClass('disk')">
                        <mat-icon>{{ getReadyComponentIcon('disk') }}</mat-icon>
                        <span>Disk: {{ getDiskStatusDisplay() }}</span>
                    </div>
                </div>
            </div>

            <!-- Disk Storage Details -->
            <div class="row mt-2" *ngIf="readyData?.components?.disk?.free_mb">
                <div class="col-12">
                    <div class="disk-info-bar">
                        <div class="disk-info-text">
                            <span class="disk-label">Spațiu liber:</span>
                            <span class="disk-value">{{ formatDiskSize(readyData.components.disk.free_mb) }}</span>
                            <span class="disk-separator">|</span>
                            <span class="disk-label">Utilizat:</span>
                            <span class="disk-value" [ngClass]="getDiskUsageClass()">{{ readyData.components.disk.usage_percent | number:'1.1-1' }}%</span>
                        </div>
                        <div class="disk-progress">
                            <div class="progress" style="height: 8px;">
                                <div class="progress-bar" [ngClass]="getDiskUsageClass()"
                                    role="progressbar"
                                    [style.width.%]="readyData.components.disk.usage_percent"
                                    [attr.aria-valuenow]="readyData.components.disk.usage_percent"
                                    aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="row mt-3">
                <div class="col-12">
                    <button mat-raised-button color="primary" (click)="testConnection()"
                        [disabled]="isTestingConnection" class="me-2"
                        *ngIf="permissionsService.hasPermission('indoc-module.administrative.signer.test-connection')">
                        <mat-icon *ngIf="!isTestingConnection">refresh</mat-icon>
                        <mat-spinner *ngIf="isTestingConnection" diameter="20" class="me-1"></mat-spinner>
                        Test Conexiune
                    </button>
                    <button mat-raised-button color="accent" (click)="testSigning()"
                        [disabled]="isTestingSigning || !isHealthy" class="me-2"
                        *ngIf="permissionsService.hasPermission('indoc-module.administrative.signer.test-sign')">
                        <mat-icon *ngIf="!isTestingSigning">verified</mat-icon>
                        <mat-spinner *ngIf="isTestingSigning" diameter="20" class="me-1"></mat-spinner>
                        Test Semnare
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Configuration Section -->
    <mat-card class="mb-3">
        <mat-card-header>
            <mat-card-title>Configurare Serviciu</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="configForm">
                <!-- Connection Settings -->
                <h5 class="mt-3">Setări Conexiune <span class="text-danger">*</span></h5>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>URL Serviciu Semnare</mat-label>
                            <input matInput type="text" formControlName="signer_service_url"
                                placeholder="http://localhost:8765" required>
                            <mat-error *ngIf="configForm.get('signer_service_url')?.hasError('required')">
                                URL-ul serviciului este obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>API Key</mat-label>
                            <input matInput type="password" formControlName="signer_api_key"
                                placeholder="API Key pentru autentificare" required>
                            <mat-error *ngIf="configForm.get('signer_api_key')?.hasError('required')">
                                API Key este obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Serviciu Activ</mat-label>
                            <mat-select formControlName="signer_enabled">
                                <mat-option value="0">Nu</mat-option>
                                <mat-option value="1">Da</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Certificat Default</mat-label>
                            <mat-select formControlName="signer_default_certificate"
                                (selectionChange)="onCertificateSelect($event.value)">
                                <mat-option *ngFor="let cert of certificates" [value]="cert.slug">
                                    {{ cert.name }} ({{ cert.slug }})
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Signature Position Defaults -->
                <h5 class="mt-3">Poziție Default Semnătură</h5>
                <div class="row">
                    <div class="col-md-2">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Pagină</mat-label>
                            <input matInput type="number" formControlName="signer_default_page" min="1">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Poziție X</mat-label>
                            <input matInput type="number" formControlName="signer_default_position_x" min="0">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Poziție Y</mat-label>
                            <input matInput type="number" formControlName="signer_default_position_y" min="0">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Lățime</mat-label>
                            <input matInput type="number" formControlName="signer_default_width" min="50">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Înălțime</mat-label>
                            <input matInput type="number" formControlName="signer_default_height" min="50">
                        </mat-form-field>
                    </div>
                </div>

                <!-- Signature Metadata -->
                <h5 class="mt-3">Metadate Semnătură <small class="text-muted">(opțional)</small></h5>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Motiv Semnare</mat-label>
                            <input matInput type="text" formControlName="signer_default_reason"
                                placeholder="Sigiliu electronic">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Locație</mat-label>
                            <input matInput type="text" formControlName="signer_default_location"
                                placeholder="București">
                        </mat-form-field>
                    </div>
                </div>

                <!-- Health Notifications -->
                <h5 class="mt-3">Notificări Status Serviciu <small class="text-muted">(opțional)</small></h5>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Webhook URL (Slack)</mat-label>
                            <input matInput type="url" formControlName="signer_health_webhook_url"
                                placeholder="https://hooks.slack.com/services/...">
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Notificări Active</mat-label>
                            <mat-select formControlName="signer_health_check_enabled">
                                <mat-option value="0">Nu</mat-option>
                                <mat-option value="1">Da</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Watermark Template -->
                <h5 class="mt-3">Șablon Watermark <span class="text-danger">*</span></h5>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Template Watermark</mat-label>
                            <textarea matInput formControlName="signer_watermark_template" rows="4" required></textarea>
                            <mat-hint>Variabile disponibile: {{ '{' }}institutionName{{ '}' }}, {{ '{' }}regNumber{{ '}' }}, {{ '{' }}regDate{{ '}' }}</mat-hint>
                            <mat-error *ngIf="configForm.get('signer_watermark_template')?.hasError('required')">
                                Șablonul watermark este obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <div class="watermark-preview">
                            <label>Previzualizare Watermark:</label>
                            <pre class="preview-text">{{ watermarkPreview }}</pre>
                        </div>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="row mt-3" *ngIf="permissionsService.hasPermission('indoc-module.administrative.signer.update')">
                    <div class="col-12">
                        <button mat-raised-button color="primary" (click)="updateConfiguration()"
                            [disabled]="!configModified || configForm.invalid">
                            <mat-icon>save</mat-icon>
                            Actualizare Configurație
                        </button>
                        <span class="ms-2 text-muted" *ngIf="!configModified">
                            <small>Nu există modificări</small>
                        </span>
                        <span class="ms-2 text-danger" *ngIf="configForm.invalid && configModified">
                            <small>Completați câmpurile obligatorii</small>
                        </span>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <!-- Certificates Section -->
    <mat-card class="mb-3">
        <mat-card-header>
            <mat-card-title>Certificate Disponibile</mat-card-title>
            <div class="card-header-actions"
                *ngIf="permissionsService.hasPermission('indoc-module.administrative.signer.sync-certificates')">
                <button mat-raised-button color="accent" (click)="syncCertificates()"
                    [disabled]="isSyncingCertificates || !isHealthy">
                    <mat-icon *ngIf="!isSyncingCertificates">sync</mat-icon>
                    <mat-spinner *ngIf="isSyncingCertificates" diameter="20" class="me-1"></mat-spinner>
                    Sincronizare Certificate
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="certificates-table" *ngIf="certificates.length > 0">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Nume</th>
                            <th>Slug</th>
                            <th>Descriere</th>
                            <th>Limită/Oră</th>
                            <th>Rămase</th>
                            <th>Resetare</th>
                            <th>Activ</th>
                            <th class="text-center">Logo Sigiliu</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cert of certificates"
                            [ngClass]="{'table-primary': cert.slug === selectedCertificateSlug}"
                            (click)="onCertificateSelect(cert.slug)" style="cursor: pointer;">
                            <td>{{ cert.name }}</td>
                            <td><code>{{ cert.slug }}</code></td>
                            <td>{{ cert.description }}</td>
                            <td>{{ cert.rate_limit_per_hour }}</td>
                            <td>
                                <span *ngIf="cert.rate_limit_status" class="rate-limit-badge"
                                    [ngClass]="getRateLimitClass(cert.rate_limit_status)">
                                    {{ cert.rate_limit_status.remaining }} / {{ cert.rate_limit_status.limit }}
                                </span>
                                <span *ngIf="!cert.rate_limit_status">-</span>
                            </td>
                            <td>
                                <span *ngIf="cert.rate_limit_status?.reset_at" class="reset-time">
                                    {{ formatResetTime(cert.rate_limit_status!.reset_at) }}
                                </span>
                                <span *ngIf="!cert.rate_limit_status?.reset_at">-</span>
                            </td>
                            <td>
                                <span class="badge" [ngClass]="cert.enabled ? 'bg-success' : 'bg-danger'">
                                    {{ cert.enabled ? 'Da' : 'Nu' }}
                                </span>
                            </td>
                            <td class="text-center" (click)="$event.stopPropagation()">
                                <div class="d-flex align-items-center justify-content-center gap-2">
                                    <!-- Logo status indicator -->
                                    <span *ngIf="hasLogo(cert.slug)" class="badge bg-success" title="Logo încărcat">
                                        <mat-icon style="font-size: 14px; height: 14px; width: 14px;">image</mat-icon>
                                    </span>
                                    <span *ngIf="!hasLogo(cert.slug)" class="badge bg-secondary" title="Fără logo">
                                        <mat-icon style="font-size: 14px; height: 14px; width: 14px;">hide_image</mat-icon>
                                    </span>

                                    <!-- Preview button (only if has logo) -->
                                    <button *ngIf="hasLogo(cert.slug)"
                                            class="btn btn-sm btn-outline-info"
                                            (click)="previewLogo(cert.slug)"
                                            title="Vizualizează logo">
                                        <mat-icon style="font-size: 16px; height: 16px; width: 16px;">visibility</mat-icon>
                                    </button>

                                    <!-- Upload button -->
                                    <input type="file"
                                           [id]="'logo-upload-' + cert.slug"
                                           accept=".jpg,.jpeg"
                                           hidden
                                           (change)="onLogoUpload($event, cert.slug)">
                                    <label [for]="'logo-upload-' + cert.slug"
                                           class="btn btn-sm btn-outline-primary mb-0"
                                           style="cursor: pointer;"
                                           title="Încarcă logo (JPEG, pătrat, 50-500px, max 100KB)">
                                        <mat-icon style="font-size: 16px; height: 16px; width: 16px;">upload</mat-icon>
                                    </label>

                                    <!-- Delete button (only if has logo) -->
                                    <button *ngIf="hasLogo(cert.slug)"
                                            class="btn btn-sm btn-outline-danger"
                                            (click)="deleteLogo(cert.slug)"
                                            title="Șterge logo">
                                        <mat-icon style="font-size: 16px; height: 16px; width: 16px;">delete</mat-icon>
                                    </button>

                                    <!-- Enable/Disable toggle (only if has logo) -->
                                    <mat-slide-toggle
                                        *ngIf="hasLogo(cert.slug)"
                                        [checked]="isLogoEnabled(cert.slug)"
                                        (change)="toggleLogo(cert.slug)"
                                        color="primary"
                                        title="Activează/Dezactivează logo pe sigiliu">
                                    </mat-slide-toggle>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="no-certificates" *ngIf="certificates.length === 0 && !isLoading">
                <p class="text-muted">
                    <mat-icon>info</mat-icon>
                    Nu există certificate disponibile. Verificați conexiunea la serviciul de semnare.
                </p>
            </div>
            <div class="mt-3" *ngIf="certificates.length > 0">
                <small class="text-muted">
                    <mat-icon style="font-size: 14px; height: 14px; width: 14px; vertical-align: middle;">info</mat-icon>
                    Logo pentru sigiliu: JPEG, pătrat (1:1), 50-500px, maxim 100KB
                </small>
            </div>
        </mat-card-content>
    </mat-card>
    </ng-container>
</div>
